import { Home } from "lucide-react";
import React from "react";

const ExamHeader = ({ examData }) => {
  return (
    <div className="flex items-center px-3 sm:px-4 lg:px-6 py-3 bg-white border-b border-gray-200 shadow-sm">
      <div className="flex items-center w-full">
        <div className="flex items-center space-x-2 sm:space-x-3 md:space-x-4">
          {/* Logo container với kích thước responsive */}
          {/* Text với responsive typography */}
          <span className="hidden md:block text-base sm:text-lg md:text-xl lg:text-2xl font-bold truncate max-w-[200px] sm:max-w-xs md:max-w-md lg:max-w-lg leading-tight">
            <a className="navbar-brand potta-one text-[1.5rem]" href="/">
              <Home />
            </a>
          </span>
          <span className="text-base sm:text-lg md:text-xl lg:text-2xl font-bold text-black truncate max-w-[270px] sm:max-w-xs md:max-w-md lg:max-w-lg leading-tight">
            {examData?.title}
          </span>
          {/* <span className="block md:hidden text-base sm:text-lg md:text-xl lg:text-2xl font-bold text-black truncate max-w-[270px] sm:max-w-xs md:max-w-md lg:max-w-lg leading-tight">
            {examData?.subject}
          </span> */}
          {/* <span className="text-base sm:text-lg md:text-xl lg:text-2xl font-bold text-[#cd1627] truncate max-w-[200px] sm:max-w-xs md:max-w-md lg:max-w-lg leading-tight">
            {getUserInfo()?.identifier}
          </span> */}
        </div>
      </div>
    </div>
  );
};

export default ExamHeader;
